import { reactive } from '@vue/reactivity'
import { VPR_TASK_RESULT_INVALID, VPR_TASK_RESULT_NONE, VPR_TASK_RESULT_VALID, VPR_TASK_RESULT_PART } from '@/config'

let progressCache = reactive({})

export function vprTaskProgressCacheClear (taskId = null) {
  if (taskId) {
    if (progressCache[taskId]) { delete progressCache[taskId] }
  } else {
    progressCache = reactive({})
  }
}
/**
 * @param  {Number} taskId
 * @param  {ChildVprTaskProgress} progress
 */
export function vprTaskProgressCacheSet (taskId, progress) {
  if (!taskId) return
  progressCache[taskId] = progress
}

export default class VprTask {
  constructor (data, subtheme, vprProgress = null) {
    if (!data || !data.id) throw new Error('Invalid VprTask data.')

    this.id = data.id

    this.parentSubtheme = subtheme

    this.title = data.task_name ?? ''

    this.iframeUrl = data.iframe_url ?? null

    this.highLevel = data.high_level ?? false

    this.order = data.order ?? 0

    this.vprProgress = vprProgress
  }

  get progress () {
    if (progressCache[this.id]) return progressCache[this.id]

    const progress = this.vprProgress && this.vprProgress?.controlworksProgress
      ? this.vprProgress.controlworksProgress.find(taskProgress => taskProgress.taskId === this.id)
      : null

    if (progress) { progressCache[this.id] = progress }

    return progress ?? null
  }

  get isNotDone () {
    return !this.progress || this.progress.status === VPR_TASK_RESULT_NONE
  }

  get isDone () {
    return !this.isNotDone
  }

  get isValid () {
    return this.progress?.status === VPR_TASK_RESULT_VALID
  }

  get isInvalid () {
    return this.progress?.status === VPR_TASK_RESULT_INVALID
  }

  get isPartAnswered () {
    return this.progress?.status === VPR_TASK_RESULT_PART
  }

  get prevTask () {
    const currentIndex = this.parentSubtheme.tasks.findIndex(task => task === this)
    return currentIndex > 0 ? this.parentSubtheme.tasks[currentIndex - 1] : null
  }

  get nextTask () {
    const currentIndex = this.parentSubtheme.tasks.findIndex(task => task === this)
    return currentIndex < this.parentSubtheme.tasks.length - 1 ? this.parentSubtheme.tasks[currentIndex + 1] : null
  }

  get basePlayerUrl () {
    return this.iframeUrl.substring(0, this.iframeUrl.indexOf('index.xhtml'))
  }

  get sourcesPlayerUrl () {
    return this.basePlayerUrl ? `${this.basePlayerUrl}sources/` : ''
  }
}
